import renderingTextureVertexShader from './RenderingTextureVertexShader.glsl';
import textureFragmentShader from './TextureFragmentShader.glsl';

const Shaders = {
  renderingTextureVertexShader,
  textureFragmentShader,
};

export default Shaders;
